import * as React from "react";
import { IoLogoWhatsapp, IoCopyOutline, IoCopy, IoLogoWechat } from "react-icons/io5";
import { BsLine } from "react-icons/bs";
import styled from "styled-components";
import { useState } from "react";

const H5Title = styled.h4`
  margin-top: 4rem;
  margin-bottom: 0px;
  font-size: 1.8rem;
`;

const ShareWithFriendsContainer = styled.div`
  margin-top: 4rem;
`;

const CopyUrlContainer = styled.div`
  margin-top: 2rem;
  display: flex;
  padding: 0.5rem 1rem;
  border: 1px solid #ccc;
  border-radius: 1rem;
`;

const UrlText = styled.div`
  margin-right: 1rem;
`;

const CopyIcon = styled(IoCopyOutline)`
  position: relative;
  font-size: 2rem;
  margin-top: 0.3rem;
  cursor: pointer;
`;

const SocialShare = styled.div`
  margin-top: 2rem;
  display: flex;
  justify-content: flex-start;
`;

const SocialIconLink = styled.a`
  display: flex;
  padding: 1rem 1rem;
  border: 0px;
  border-radius: 1rem;
  margin-right: 2rem;
  background: #09b83e;
  color: white;
  font-weight: bold;
  font-size: 2rem;
`;

const WechatIcon = styled(IoLogoWechat)`
  size: 2rem;
`;
const WhatsappSocialIcon = styled(IoLogoWhatsapp)`
  size: 2rem;
`;
const LineIcon = styled(BsLine)`
  size: 2rem;
`;

const SocialIconText = styled.div`
  margin-left: 1rem;
`;

export const ShareWithFriends = ({ restaurant, locale }) => {
	const [isCopied, setIsCopied] = useState(false);
	let url = '';
	const baseUrl = typeof window !== 'undefined' ? window.location.origin : 'https://www.ajisen.com.hk/';
	const localePath = locale === "en" ? "en/" : "";
	url = `${baseUrl}/${localePath}contact-us/${restaurant.slug}`;
	
  return (<ShareWithFriendsContainer>
		<H5Title>{locale === "en" ? "Share with a friend" : "分享給朋友"}</H5Title>
		<CopyUrlContainer>
			<UrlText>{url}</UrlText>
			<CopyIcon 
				className={isCopied ? "fade-in" : "fade-out"}
				as={isCopied ? IoCopy : IoCopyOutline}
				onClick={() => {
					navigator.clipboard.writeText(url);
					setIsCopied(true);
					setTimeout(() => setIsCopied(false), 3000);
			}} />
		</CopyUrlContainer>
		<SocialShare>
			<SocialIconLink
				href={`https://web.wechat.com/share?url=${encodeURIComponent(url)}`}
				target={"_blank"}
			>
				<WechatIcon size={"3rem"} />
				<SocialIconText>{locale === "en" ? "Share" : "分享"}</SocialIconText>
			</SocialIconLink>

			<SocialIconLink
				href={`https://api.whatsapp.com/send?text=${encodeURIComponent(url)}`}
				target={"_blank"}
			>
				<WhatsappSocialIcon size={"3rem"} />
				<SocialIconText>{locale === "en" ? "Share" : "分享"}</SocialIconText>
			</SocialIconLink>

			<SocialIconLink
				href={`https://social-plugins.line.me/lineit/share?url=${encodeURIComponent(url)}`}
				target={"_blank"}
			>
				<LineIcon size={"3rem"} />
				<SocialIconText>{locale === "en" ? "Share" : "分享"}</SocialIconText>
			</SocialIconLink>
		</SocialShare>
	</ShareWithFriendsContainer>);
};